(() => {
  if (window.SKULL_PROMO_CLOCK) return;
  const config = window.SKULL_PROMO_CLOCK_CONFIG || {};
  const zone = config.timeZone || 'America/Mexico_City';
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const subscribers = new Set();
  let timer = 0;
  const now = () => Date.now();
  function calendar(timestamp) {
    return Object.fromEntries(formatter.formatToParts(timestamp)
      .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  }
  function nextMidnight(timestamp) {
    const day = calendar(timestamp);
    const localMidnight = Date.UTC(day.year, day.month - 1, day.day + 1);
    let target = localMidnight;
    // Resolve the store's local midnight without using the visitor's time zone.
    for (let attempt = 0; attempt < 2; attempt++) {
      const parts = calendar(target);
      const offset = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - target;
      target = localMidnight - offset;
    }
    return target;
  }
  let deadline = nextMidnight(now());
  function snapshot() {
    const current = now();
    if (current >= deadline) deadline = nextMidnight(current);
    return { remainingMs: Math.max(0, deadline - current), deadline, expired: false };
  }
  function publish() {
    const state = snapshot();
    for (const subscriber of subscribers) {
      try { subscriber(state); } catch (error) { console.error('SKULL countdown view:', error); }
    }
  }
  function schedule() {
    clearTimeout(timer);
    timer = 0;
    if (document.hidden || !subscribers.size) return;
    timer = setTimeout(() => { publish(); schedule(); }, 1000 - (now() % 1000) + 15);
  }
  window.SKULL_PROMO_CLOCK = {
    snapshot,
    subscribe(callback) {
      if (typeof callback !== 'function') return () => {};
      subscribers.add(callback);
      callback(snapshot());
      schedule();
      return () => { subscribers.delete(callback); schedule(); };
    }
  };
  document.addEventListener('visibilitychange', () => { if (!document.hidden) publish(); schedule(); });
  window.addEventListener('pagehide', () => { clearTimeout(timer); timer = 0; });
  window.addEventListener('pageshow', () => { publish(); schedule(); });
  document.dispatchEvent(new CustomEvent('skull:promo-clock-ready'));
})();
